import { set } from '@imcc/utilities';

export function toggleShowReducer(state) {
  const isShown = state.tabs[state.indexName].showFilters;

  return set(state, ['tabs', state.indexName, 'showFilters'], !isShown);
}
